module.exports = __webpack_public_path__ + "static/img/point-bg.6d4e8e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/point-bg.png
// module id = 3S6P
// module chunks = 0